<template>
    <div v-if="isVisible">
        <div class="modal fade" :class="{'in': isVisible, 'open': isVisible}" role="dialog"
             aria-labelledby="registrationModal" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body" v-if="submitChallengeRequest.loaded && !submitChallengeRequest.error && isInteractFinishedOrNotNeeded">
                        <div style="margin-top: 2rem; margin-bottom: 4rem;" v-if="!isSponsored && isInteractFinishedOrNotNeeded">
                            <h1 class="modal-title text-center"><img src="/assets/icons/Success.png"  alt="An icon with a white check mark in a green circle" style="height: 4rem; margin-top: -5px;margin-right: 0;"/> Challenge <strong>abgegeben!</strong></h1>
                        </div>

                        <div class="row" style="margin-top: 3rem;" v-if="isSponsored">
                            <div class="col-lg-12">
                                <div>
                                    <h2 class="text-center" style="margin-bottom: 3rem; color: #141414;"><img src="/assets/icons/Success.png"  alt="An icon with a white check mark in a green circle" style="height: 4rem; margin-top: -5px;margin-right: 0;"/> Diese Challenge
                                        ist gesponsert von
                                        <router-link
                                                :to="{ name: 'company-profile', params: { slug: companySlug }}"><strong>{{sponsoringData.name}}</strong>
                                        </router-link>
                                        .
                                    </h2>
                                    <router-link
                                            :to="{ name: 'company-profile', params: { slug: companySlug }}"><img
                                            :src="sponsoringData.logo" :alt="'Logo of the sponsor '+sponsoringData.name"
                                            class="center-block" style="max-width: 65%; max-height: 150px;"/>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center" style="margin-top: 2rem">
                                <a v-if="twitterHandle !== null && twitterHandle !== ''" class="btn btn-primary" style="margin-right: 1rem;" data-size="large" :href="getRandomThankYouText" data-show-count="false" target="_blank"><span class="fa fa-twitter">&nbsp;</span>Danke auf Twitter sagen</a>
                            </div>
                        </div>

                        <div class="row reward-row" v-if="!this.$features.WHITELABEL && (selectedReward !== 'WITHOUT_SPONSORING_AFTER_CONTACT' || isInteractFinishedOrNotNeeded)">
                            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 animated flipInY reward-cell" style="animation-delay: 100ms;">
                                <div class="success-panel" style="height: 100%; ">
                                    <img v-if="!isDonatableOnly" src="/assets/icons/Rich-Retro.png" alt="An icon with a big moneybag" class="header-icon"/>
                                    <img v-if="isDonatableOnly" src="/assets/icons/eherz-new-color.png" alt="An icon with a heart and the eh logo in it" class="header-icon"/>
                                    <h1 class="text-center reward-text" v-if="selectedReward === 'WITH_SPONSORING'">{{rewardSponsored}} <img src="/assets/img/coins.png" alt="An icon with coins" style="height: 2.5rem; margin-top: -5px"/></h1>
                                    <h1 class="text-center reward-text" v-if="selectedReward==='WITH_SPONSORING_AFTER_CONTACT' || selectedReward === 'WITHOUT_SPONSORING'">{{rewardDefault}} <img src="/assets/img/coins.png" alt="An icon with coins" style="height: 2.5rem; margin-top: -5px"/></h1>
                                    <h1 class="text-center reward-text" v-if="selectedReward === 'WITHOUT_SPONSORING_AFTER_CONTACT'">{{rewardInteract}} <img src="/assets/img/coins.png" alt="An icon with coins" style="height: 2.5rem; margin-top: -5px"/></h1>
                                    <p v-if="isDonatableOnly" style="font-weight: bold;" class="text-center">gespendet</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 animated flipInY reward-cell" style="animation-delay: 500ms;">
                                <div class="success-panel" style="height: 100%; ">
                                    <img src="/assets/icons/Stars-and-badge.svg"
                                         class="header-icon" alt="An icon with a badge and stars"/>
                                    <h1 class="text-center reward-text">300 <strong style="height: 2.5rem">XP</strong></h1>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 animated flipInY reward-cell" style="animation-delay: 900ms;">
                                <div class="success-panel" style="height: 100%;">
                                    <img src="/assets/icons/skillset.svg" style="height: 70px"
                                         class="header-icon" alt="An icon with a lightbulb representing your technology skills"/>
                                    <h1 class="text-center reward-text">+{{ getPercentageTechnologyScore }}%</h1>
                                    <p class="text-center">Auf deinen <strong>{{ getLanguageDisplayName }}</strong> Skill in deinem Profil.</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 animated fadeIn reward-cell" style="animation-delay: 1300ms;" v-if="sponsoringAfterContact">
                                <div class="success-panel inactive" >
                                    <img src="/assets/icons/Favorite%20Mail-Greyscale.png"
                                         class="header-icon" alt="An icon with an envelope and a star"/>
                                    <h1 class="text-center reward-text">{{rewardSponsored}} <img src="/assets/img/coins.png" alt="An icon with coins" style="height: 2.5rem; margin-top: -5px"/></h1>
                                    <p class="text-center" v-if="typeof sponsoringData.name !== 'undefined'">Wenn <strong>{{ sponsoringData.name }}</strong> dich kontaktiert.</p>
                                    <p class="text-center" v-if="typeof sponsoringData.name === 'undefined'">Wenn Du von einem Unternehmen kontaktiert wirst.</p>
                            </div>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 3rem;">
                            <div class="col-lg-12 text-center">
                                <button class="btn btn-secondary" :class="{'btn-cta': !isEntwicklerHerzFeatureFlag}" style="" v-on:click="closeModal()" v-show="isInteractFinishedOrNotNeeded"><i
                                    class="dev-check">&nbsp;</i>Schließen
                                </button>
                                <button v-if="isEntwicklerHerzFeatureFlag && !isDonatableOnly && !this.$features.WHITELABEL" class="btn btn-entwicklerherz" v-on:click="redirectToDonate()" v-show="isInteractFinishedOrNotNeeded"><i
                                        class="dev-heart">&nbsp;</i>Coins Spenden
                                </button>
                                <a v-if="isDonatableOnly" class="twitter-share-button btn btn-primary btn-lg donate-button" style="margin-right: 1rem;"
                                   data-size="large" :href="getStayHomeAndCodeTweet" data-show-count="false"
                                   target="_blank"><span class="fa fa-twitter">&nbsp;</span>Spendenaktion teilen
                                </a>


                            </div>
                        </div>
                    </div>

                    <div class="modal-body interact" v-if="!isInteractFinishedOrNotNeeded">
                        <div class="row" style="margin-top: 4rem; margin-bottom: 3rem;">
                            <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12">
                                <PostChallengeInteract v-if="!isSponsored" :challenge="challenge" :interactFinishedHandler="interactFinished"></PostChallengeInteract>
                                <PostChallengeInteract v-if="isSponsored" :company-id="sponsoringData.companyId" :challenge="challenge" :interactFinishedHandler="interactFinished"></PostChallengeInteract>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body" v-if="isInteractFinishedOrNotNeeded && !submitChallengeRequest.loaded">
                        <div style="margin-top: 2rem; margin-bottom: 4rem;">
                            <h1 class="modal-title text-center"><span class="fa loading-spinner loading-spinner-green loading-spinner-big"></span> Challenge <strong>wird abgegeben...</strong></h1>
                        </div>
                    </div>

                    <div class="modal-body"
                         v-if="isInteractFinishedOrNotNeeded && submitChallengeRequest.loaded && submitChallengeRequest.error">

                        <div class="row">
                            <ErrorComponent message="Challenge konnte nicht abgegeben werden.">
                                Beim Abgeben ist etwas schief gelaufen. Das EntwicklerHeld Team wurde informiert. Probier es später erneut. Sollte das Problem weiter bestehen, schreib uns über den Feedback-Button.
                            </ErrorComponent>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-lg btn-cta" style=""
                                    v-on:click="closeModal()"><i
                                    class="dev-check">&nbsp;</i>Schließen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in" v-if="isVisible"></div>
    </div>
</template>

<script>
    import PostChallengeInteract from "../interacts/PostChallengeInteract";
    import {eventBus, services} from "../../main";
    import {LANGUAGES} from "../../const";
    import ErrorComponent from "../ErrorComponent";
    import {isInstantDonationChallenge} from "../../services/Utilities";

    export default {
        name: "ReceiveRewardComponent",
        components: {ErrorComponent, PostChallengeInteract},
        props: {
            challenge: {type: [Object], default: () => null},
            isVisible: {type: [Boolean], default: {}},
            closeHandler: {type: [Function], default: {}},
            acceptHandler: {type: [Function], default: {}},
            isSponsored: {type: [Boolean], default: false},
            additionalReward: {type: [Boolean], default: false},
            sponsoringData: {type: [Object], default: {}},
            selectedReward: {type: [String], default: ""},
            companySlug: {type: [String], default: ""},
            rewardSponsored: {type: [Number], default: 0},
            rewardDefault: {type: [Number], default: 0},
            rewardInteract: {type: [Number], default: 0},
            twitterHandle: {type: [String], default: null},
        },

        data() {
            return {
                isInteractFinishedOrNotNeeded: false,
                submitChallengeRequest: {loaded: false, error: null},
            }
        },
        methods: {
            closeModal() {
                this.closeHandler();
                // resets the component when the close button is pressed
                Object.assign(this.$data, this.$options.data());
            },
            redirectToDonate() {
                eventBus.$emit('open-donate-modal');
                this.closeHandler();
            },
            acceptCampaign(sponsoringOption) {
                this.closeModal();
            },
            interactFinished() {
                this.isInteractFinishedOrNotNeeded = true;
            },
            isVisibleChanged() {
                if (this.isVisible && this.selectedReward === 'WITHOUT_SPONSORING') {
                  this.isInteractFinishedOrNotNeeded = true;
                  return;
                }
                if (this.isInteractFinishedOrNotNeeded && this.isVisible) {
                  this.submitChallengeRequest = services.taskManagementService.submitChallenge(this.challenge.id);
                }
            }
        },
        updated() {
            this.$nextTick(function () {

            })
        },
        mounted() {
            this.isVisibleChanged();
        },
        watch: {
          "isInteractFinishedOrNotNeeded": function() {
              if (this.isInteractFinishedOrNotNeeded && this.isVisible) {
                  this.submitChallengeRequest = services.taskManagementService.submitChallenge(this.challenge.id);
              }

          },
          "isVisible": function() {
              this.isVisibleChanged()
          },
          'submitChallengeRequest.loaded': function () {
                if (!this.submitChallengeRequest.loaded || this.submitChallengeRequest.error !== null) {
                    return;
                }

                services.googleAnalytics.sendEvent('Challenge', 'submit', this.challenge.id);
                services.facebookAnalytics.sendSolvedChallengeEvent();
                eventBus.$emit('user-coins-changed');
                eventBus.$emit("coins-donated");
                eventBus.$emit("challenge-submitted");
            },
        },
        computed: {
            isEntwicklerHerzFeatureFlag: function() {
                return window.ENTWICKLER_HERZ_FEATURE_FLAG;
            },
            isDonatableOnly() {
                return isInstantDonationChallenge(this.challenge.id);
            },
            sponsoringAfterContact: function () {
                return this.selectedReward === "WITH_SPONSORING_AFTER_CONTACT";
            },
            getRandomThankYouText: function() {

              const texts = [
                  "Danke%20%40" + this.twitterHandle + "%20f%C3%BCr%20die%20tolle%20Challenge%20auf%20%40EntwicklerHeld%21 %23EntwicklerHeld",
                  "Ich%20habe%20gerade%20die%20Challenge%20von%20%40" + this.twitterHandle + "%20auf%20%40EntwicklerHeld%20gel%C3%B6st%21%20Danke%20f%C3%BCrs%20sponsern%21%20%23EntwicklerHeld",
              ];

                return "https://twitter.com/intent/tweet?text="+texts[Math.floor(Math.random()*texts.length)]+"&related=EntwicklerHeld"
            },
            getStayHomeAndCodeTweet: function () {
                const text = "Ich+habe+an+der+%23StayHomeAndCode+Spendenaktion+von+%40EntwicklerHeld+teilgenommen+und+konnte+durchs+Coden+5€+an+die+%40AktionDHilft+spenden%21+Macht+mit+auf+http%3A%2F%2Fstayhomeandcode.de%2F+und+%23StandWithUkraine%21+<3";
                return "https://twitter.com/intent/tweet?text="+text+"&related=EntwicklerHeld"
            },
            getPercentageTechnologyScore: function () {
                if (this.challenge.complexity === 1) {
                    return 72/360 * 100;
                } else if (this.challenge.complexity === 2) {
                    return 90/360 * 100;
                } else if (this.challenge.complexity === 3) {
                    return 108/360 * 100;
                } else if (this.challenge.complexity === 4) {
                    return 216/360 * 100;
                } else {
                    return 90/360 * 100;
                }
            },
            getLanguageDisplayName: function () {
                return LANGUAGES[this.challenge.technology.language.toLowerCase()];
            },
        }
    }
</script>

<style scoped>
    .open {
        display: block;
    }

    .modal-content {
        padding: 3rem;
        padding-top: 1rem;
        background: linear-gradient(135deg, #f5f8ff, #fafcff);
    }

    .modal-body {
        max-width: 1200px;
        margin: 0 auto;
    }

    .modal-body.interact {
        max-width: none;
    }

    .modal-dialog {
        width: 80%;
    }

    .modal-header {
        margin-bottom: 3.5rem;
    }

    .modal-title {
        margin-bottom: 1.5rem;
        font-size: 4rem;
    }

    .modal-title img {
        height: 35px;
        margin-right: 1rem;
        margin-top: -5px;
    }

    .success-panel:not(.inactive):hover {
        box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.19);
        -webkit-box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.19);
    }
    .success-panel {
        background-color: white;
        background: linear-gradient(135deg, white, #f6f8fa);
        border-radius: 1rem;
        box-sizing: border-box;
        padding: 3.5rem 2.5rem;
        flex: 1;
        box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.09);
        -webkit-box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.09);
        transition: all 300ms linear;
    }

    .header-icon {
        width: 7rem;
        display: block;
        margin: 0.5rem auto
    }
    .inactive {
        opacity: .5;
        filter: grayscale(1);
    }
    .reward-text {
        font-weight: 500;
    }

    @media only screen and (max-width: 1000px) {
        .modal-dialog {
            width: 100%;
            max-width: 1200px;
        }

        .reward-text {
            font-size: 1.9rem;
        }
    }
    .donate-button {
        background-image: -webkit-linear-gradient(0deg, rgb(255, 89, 97) 0%, #e74c3c 100%);
        color: white;
    }

    .reward-row {
        margin-top: 7rem;
        margin-bottom: 7rem;
        display: flex;
    }

    @media only screen and (max-width: 768px) {
        .reward-row {
            display: block;
        }

        .reward-cell {
            margin-bottom: 20px;
        }
    }

</style>
